<template>
    <div>
        <v-simple-table dense :key="tableKey">
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">Название:</th>
                    <th class="text-left">Значение:</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Общее количество вопросов:</td>
                    <td>{{ report.final.percantage.all }}</td>
                </tr>
                <tr>
                    <td>Количество исключенных:</td>
                    <td>{{ report.final.percantage.excl }}</td>
                </tr>
                <tr>
                    <td>Итого максимум баллов:</td>
                    <td>{{ report.final.percantage.maxpoints }}</td>
                </tr>
                <tr>
                    <td>Начислено баллов:</td>
                    <td>{{ report.final.percantage.points }}</td>
                </tr>
                <tr>
                    <td>Максимум баллов за блок "Превосходя ожидания":</td>
                    <td>{{ report.final.percantage.clientPlusMax }}</td>
                </tr>
                <tr>
                    <td>Начислено баллов за блок "Превосходя ожидания":</td>
                    <td>{{ report.final.percantage.clientPlus }}</td>
                </tr>
                <tr>
                    <td>Итого начислено:</td>
                    <td>{{ report.final.percantage.final }}</td>
                </tr>
                <tr>
                    <td>Результат (%):</td>
                    <td>{{ report.final.percantage.percent }}%</td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-row class="text-center">
            <v-col cols="12"><v-btn v-if="!!showAdminUI" @click="calculatePercentage" color="info">Пересчитать %%</v-btn></v-col>
        </v-row>
    </div>
</template>

<script>
  export default {
    name: 'reportPercentage',
    props: ['value', 'mode'],
    data() {
      return {
        tableKey: 10,
        report: this.value,
        copyReport: null,
        percantage: {
          all: 0,
          excl: 0,
          maxpoints: 0,
          points: 0,
          clientPlusMax: 0,
          clientPlus: 0,
          final: 0,
          percent: 0
        }
      }
    },
    computed: {
      showAdminUI() {
        if(this.mode) {
          return this.mode === 'manager'
        } else {
          return true
        }
      },
    },
    methods: {
      calculatePercentage() {
        let all = this.report.points.filter(p => p.admin_block_id !== 14 && p.admin_block_id !== 9)
        let excl = this.report.points.filter(p => !!p.exclude)
        let allWOExcluded = this.report.points.filter(p => p.admin_block_id !== 14 && p.admin_block_id !== 9 && !p.exclude)
        let clientPlus = this.report.points.filter(p => p.admin_block_id === 9 && !p.exclude)


        this.report.final.percantage = JSON.parse(JSON.stringify(this.percantage))

        this.report.final.percantage.all = all.length
        this.report.final.percantage.excl = excl.length
        this.report.final.percantage.maxpoints = allWOExcluded.length
        this.report.final.percantage.clientPlusMax = clientPlus.length * 2



        let points = 0
        let clientPlusPoints = 0

        for(let pnt of allWOExcluded) {
          points += pnt.point_to_reports
        }

        for(let pnt of clientPlus) {
          clientPlusPoints += pnt.point_to_reports
        }

        this.report.final.percantage.points = points
        this.report.final.percantage.clientPlus = clientPlusPoints
        this.report.final.percantage.final = clientPlusPoints + points
        this.report.final.percantage.percent = ((+(clientPlusPoints) + (points)) / +(allWOExcluded.length) * 100).toFixed(2)

        this.tableKey = 11 + Math.floor((99 - 11) * Math.random())

        console.log({
          points: this.report.final.percantage.points,
          clientPlus: this.report.final.percantage.clientPlus,
          final: this.report.final.percantage.final,
          percent: this.report.final.percantage.percent
        })

        this.$emit('input', this.report)
        this.$nextTick(function () {
          this.$emit('change')
        })

      }
    },
  }
</script>

<style scoped>

</style>